import { FilterDate } from '../baseInputTypes/FilterDate'

type Props = {}
export const ModifiedFromDate = (props: Props) => (
  <FilterDate
    label="Modified From"
    fieldName="modifiedFrom"
    fieldPath="mediaDetails.modifiedFrom"
  />
)

export const ModifiedToDate = (props: Props) => (
  <FilterDate
    label="Modified To"
    fieldName="modifiedTo"
    fieldPath="mediaDetails.modifiedTo"
  />
)
